import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown';
import { containers, Grid } from 'style';
import { DataStoreService } from 'utils';
import PersonCardImageComponent from '../subcomponents/personCardImage.component';


class Person extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            people: null,
        };
    }

    componentDidMount() {
        this.setState(() => ({
            people: DataStoreService.getPeople(),
        }));
    }

    render() {
        const { name, title, image, about, phone, email, linkedin, twitter, showMeet = false, slug } = this.props;
        return (
            <div id="Person">
                <Grid.Row>
                    <Grid.Col>
                        <PersonWrapper>
                            <ImageWrapper className="image_wrapper">
                                <PersonCardImageComponent image={image} />
                            </ImageWrapper>
                            <DetailsWrapper>
                                <PersonName>{name}</PersonName>
                                <Jobtitle>{title}</Jobtitle>
                                <Details>
                                    <About className="markdown">
                                        <ReactMarkdown source={about}
                                            renderers={{ root: 'div' }} />
                                    </About>
                                    <ContactWrapper className="markdown">
                                        <div>
                                            {phone && <h4><a href={`tel:${phone}`}>{phone}</a> <br /></h4>}
                                            {email && <h4><a href={`mailto:${email}`}>{email}</a> <br /></h4>}
                                            {linkedin && !showMeet && <h4><a href={linkedin}>LinkedIn</a> <br /></h4>}
                                            {twitter && !showMeet && <h4><a href={twitter}>Twitter</a></h4>}
                                            {showMeet && <h4><a href={`/person/${slug}`}>Meet {name.split(' ')[0]}</a> >></h4>}
                                        </div>
                                    </ContactWrapper>
                                </Details>
                            </DetailsWrapper>
                        </PersonWrapper>
                    </Grid.Col>
                </Grid.Row>
            </div>
        );
    }
}

const PersonWrapper = styled.div`

    padding: 0;
    @media (min-width: ${containers.medium}px) {
      padding: 0 ${100 / 18 * 2}vw;
    }

    @media (min-width: ${containers.medium}px) {
      display: flex;
    }
`;
const ImageWrapper = styled.div`
    width: 100%;

    margin-bottom: ${100 / 18 * 2}vw;

    @media (min-width: ${containers.small}px) {
      width: ${100 / 18 * 5}vw;
    }

    @media (min-width: ${containers.medium}px) {
      width: ${100 / 18 * 3}vw;
      margin: 0;
    }
    /* display: none; */
`;

// const inline_photo = css`
//     display: block;
//     max-width: 400px;
//     @media (min-width: ${containers.medium}px) {
//       display: none;
//     }
// `
const PersonName = styled.h3`
  margin-bottom: 0;
`;
const Jobtitle = styled.p`

`;

const DetailsWrapper = styled.div`
    flex: 1 1 100%;
    max-width: 800px;

    h4{
      @media (min-width: ${containers.medium}px) {
        text-align: left;
      }
    }


    @media (min-width: ${containers.medium}px) {
      max-width: auto;
      margin-left: ${100 / 18 * 2}vw;
      flex: 1;
    }

    @media (min-width: ${containers.innerPX}px) {
      flex: 0 0 100%;
      max-width: ${100 / 18 * 5}vw;
    }
`;
const Details = styled.div`
  display: block;
  flex: 1 1 100%;
  flex-wrap: wrap;

`;
const ContactWrapper = styled.div`

  @media (min-width: ${containers.medium}px) {
    display: block;
  }
`;

const About = styled.div`


  @media (min-width: ${containers.medium}px) {
    width: ${100 / 18 * 5};
  }
`;

export default Person;
